import { Fragment, h } from 'preact';
import { useContext, useEffect, useMemo, useRef } from 'preact/hooks';
import { ItemsContext } from './ItemsProvider';

import BundleItem from './BundleItem';

const BundleItemList = () => {
  const { state } = useContext(ItemsContext);
  const articleRef = useRef(null);

  const { contents, extras } = useMemo(() => {
    const contents = state.items.filter(
      (item) => item.productType == 'included'
    );
    const extras = state.items.filter((item) => item.productType == 'extra');
    return { contents, extras };
  }, [state]);

  // useEffect(() => {
  //   if (state.bundleInCart) {
  //     articleRef.current.classList.remove('has-extras');
  //   }
  // }, [state.bundleInCart]);

  return (
    <article
      ref={articleRef}
      className={`bundle-items ${extras.length ? 'has-extras' : ''}`}
    >
      {/* {!state.bundleInCart ? ( */}
      <div>
        <h4>Bundle Contents</h4>
        <ul className="bundle-item__list">
          {contents.map((item) => {
            return <BundleItem item={item} />;
          })}
        </ul>
      </div>
      {/* ) : null} */}
      {extras.length && extras.length > 0 ? (
        <div>
          <h4>Bundle Extras</h4>
          <ul className="bundle-item__list">
            {extras.map((item) => {
              return <BundleItem item={item} />;
            })}
          </ul>
        </div>
      ) : null}
    </article>
  );
};

export default BundleItemList;
